module.exports = __webpack_public_path__ + "static/media/30OIOS7.8a276dd6.jpg";